import React from 'react';
import PropTypes from 'prop-types';

const Backdrop = ({ onClick }) => (
  <div
    className="backdrop"
    onClick={onClick}
    style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.2)',
      zIndex: 9, 
    }}
  />
);

Backdrop.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default Backdrop;
